import { http } from 'connex-cds';

export default {
  listScheduledLoadAssignments: ({ entityRef, queryParams }) =>
    http.get({
      apiName: 'mt',
      path: `/${entityRef}/scheduled-load-assignments`,
      queryParams,
    }),
};
